import { ComponentProps } from 'react';
import Avatar from '@alltrails/denali/components/Avatar';
import styles from './ReviewSummaryAvatars.module.scss';

const MAX_AVATAR_COUNT = 3;

type ReviewSummaryAvatarsProps = {
  avatars: Pick<ComponentProps<typeof Avatar>, 'userId' | 'userName'>[];
};

const ReviewSummaryAvatars = ({ avatars }: ReviewSummaryAvatarsProps) => (
  <div className={styles.avatarContainer} suppressHydrationWarning>
    {avatars.slice(0, MAX_AVATAR_COUNT).map(({ userId, userName }) => (
      <Avatar key={userId} className={styles.avatar} size="sm" userId={userId} userName={userName} testId={`review-summary-avatar-${userId}`} />
    ))}
  </div>
);

export default ReviewSummaryAvatars;
